// extracted by mini-css-extract-plugin
module.exports = {"header":"_8d78ac2"};